import { ThemeProvider, createTheme } from '@material-ui/core'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { QueryClientProvider as TanstackQueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools as TanstackQueryDevtools } from '@tanstack/react-query-devtools'
import { CkeditorZIndexWrapper } from 'components/ckeditor/ckeditor-zindex-wrapper'
import { SuccessSnackbar } from 'components/snackbar'
import { queryClient, tanstackQueryClient } from 'config/tanstack-query'
import { useFlags } from 'launchdarkly-react-client-sdk'
import Maintenance from 'pages/maintenance'
import React from 'react'
import { QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { Provider } from 'react-redux'
import Routes from 'routes/routes'
import store from 'store'
import { ThemeProvider as CsMuiThemeProvider } from 'theme'

export default function AppMaintenanceDeterminer(): JSX.Element {
	const { showAdminMaintenancePage } = useFlags()
	if (showAdminMaintenancePage) {
		return <Maintenance />
	}

	return <App />
}

const App: React.FC<Record<string, never>> = () => {
	const theme = createTheme({ palette: { primary: { main: '#2b2c2e' }, secondary: { main: '#ffc213' } } })

	return (
		<TanstackQueryClientProvider client={tanstackQueryClient}>
			<QueryClientProvider client={queryClient}>
				<Provider store={store}>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<CsMuiThemeProvider>
							<ThemeProvider theme={theme}>
								<SuccessSnackbar />
								<CkeditorZIndexWrapper />
								<Routes />
							</ThemeProvider>
						</CsMuiThemeProvider>
					</LocalizationProvider>
				</Provider>
				<TanstackQueryDevtools />
				<ReactQueryDevtools />
			</QueryClientProvider>
		</TanstackQueryClientProvider>
	)
}
